{
  "$schema": "http://json.schemastore.org/package",
  "name": "verdaccio-github-oauth-ui",
  "version": "6.0.11",
  "keywords": [
    "authentication",
    "github",
    "login",
    "npm",
    "oauth",
    "package",
    "private",
    "registry",
    "verdaccio",
    "verdaccio-auth",
    "verdaccio-auth-plugin",
    "verdaccio-plugin"
  ],
  "homepage": "https://github.com/n4bb12/verdaccio-github-oauth-ui/blob/master/README.md",
  "bugs": "https://github.com/n4bb12/verdaccio-github-oauth-ui/issues",
  "repository": "github:n4bb12/verdaccio-github-oauth-ui",
  "license": "MIT",
  "author": "Abraham Schilling",
  "main": "dist/server/index.js",
  "bin": "dist/cli/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "bash run build",
    "clean": "bash run clean",
    "cli": "bash run cli",
    "cli:login": "bash run cli-login",
    "cli:publish": "bash run cli-publish",
    "cli:whoami": "bash run cli-whoami",
    "copy": "bash run copy",
    "coverage": "vitest --coverage",
    "dev": "yarn update && yarn start",
    "docker": "bash run docker_",
    "fix": "yarn format && yarn typecheck",
    "format": "prettier --write \"**/*.{ts,js,css,scss,html,json}\"",
    "format:check": "prettier --check \"**/*.{ts,js,css,scss,html,json}\"",
    "prepack": "bash run clean && bash run build",
    "start": "verdaccio -c verdaccio.yaml",
    "test": "vitest",
    "typecheck": "bash run typecheck",
    "update": "yarn prepack && yarn copy",
    "watch": "nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \"yarn dev\""
  },
  "dependencies": {
    "@octokit/oauth-methods": "^4.1.0",
    "@octokit/request": "^8.4.1",
    "@verdaccio/url": "^11.0.0-6-next.42",
    "dotenv": "^16.4.7",
    "express": "^4.21.2",
    "global-agent": "^3.0.0",
    "lodash": "^4.17.21",
    "memory-cache": "^0.2.0",
    "minimist": "^1.2.8",
    "octokit": "^3.2.1",
    "open": "^8.4.2",
    "ow": "^0.28.2",
    "picocolors": "^1.1.1",
    "query-string": "^7.1.3"
  },
  "devDependencies": {
    "@parcel/config-default": "~2.4.1",
    "@parcel/transformer-typescript-tsc": "~2.4.1",
    "@types/express": "^4.17.21",
    "@types/global-agent": "^2.1.3",
    "@types/lodash": "^4.17.16",
    "@types/memory-cache": "^0.2.6",
    "@types/minimist": "^1.2.5",
    "@types/node": "^20.12.14",
    "@types/query-string": "^6.3.0",
    "@verdaccio/types": "^10.8.0",
    "@vitest/coverage-v8": "^3.0.9",
    "browserslist": "^4.24.4",
    "core-js": "^3.41.0",
    "nodemon": "^3.1.9",
    "parcel": "~2.4.1",
    "prettier": "^3.5.3",
    "process": "^0.11.10",
    "release-it": "^18.1.2",
    "timekeeper": "^2.3.1",
    "type-fest": "^4.38.0",
    "typescript": "^5.8.2",
    "verdaccio": "~5.33.0",
    "verdaccio-htpasswd": "^10.5.5",
    "vitest": "^3.0.9"
  },
  "peerDependencies": {
    "verdaccio": ">=5"
  },
  "packageManager": "yarn@4.8.1",
  "publishConfig": {
    "registry": "https://registry.npmjs.org/"
  },
  "targets": {
    "client": {
      "source": "src/client/verdaccio-5.ts",
      "distDir": "dist/client",
      "context": "browser",
      "includeNodeModules": true
    },
    "server": {
      "source": "src/server/index.ts",
      "distDir": "dist/server",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false,
      "isLibrary": true
    },
    "cli": {
      "source": "src/cli/index.ts",
      "distDir": "dist/cli",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false
    }
  }
}
